import $ from 'jquery'
import angular from 'angular'

export default navbarOpacity

/** @ngInject */
function navbarOpacity($timeout) {
    return ({
        restrict: 'C',
        link: {
            post(scope, element) {
                const getHeaderHeight = function () {
                    const $navLanding = angular.element('header.nav-landing')[0]
                    if ($navLanding) {
                        return $navLanding.getBoundingClientRect().height
                    }
                    return 0
                }

                const updateOpacity = function () {
                    const headerHeight = getHeaderHeight()
                    const offsetBegin = headerHeight / 3
                    const offsetEnd = headerHeight - 72
                    const viewportTop = angular.element(window).scrollTop()
                    if (viewportTop < offsetBegin) {
                        element.css('opacity', 0)
                        return element.css('visibility', 'hidden')
                    } else if (viewportTop > offsetEnd) {
                        element.css('opacity', 100)
                        return element.css('visibility', 'visible')
                    }
                    element.css('opacity', (viewportTop - offsetBegin) / (offsetEnd - offsetBegin))
                    return element.css('visibility', 'visible')
                }

                $(window).on('scroll.navbarOpacity', updateOpacity)
                $timeout(updateOpacity)

                return scope.$on('$destroy', () => $(window).off('.navbarOpacity'))
            },
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/landing/navbarOpacity.js